import { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Pickers(): Components {
  return {};
}
